
export class OrganizationCustomer {
    public id: number;
    public customerNumberID: number;
    public customerOrganizationTypeId: number;
    public effectiveDate: string;
    public endDate: Date;
}
